var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.414 2H6C4.897 2 4 2.898 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V6.586L15.414 2ZM7 12H15V14H7V12ZM17 18H7V16H17V18ZM14 8V3L19 8H14Z",
    fill: "#5E35B1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 12,
    height: 8,
    fill: "#5E35B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5506 14.9975V14.3636H10.5371V14.9975H9.42383V18H8.66388V14.9975H7.5506ZM11.7498 14.3636L12.4831 15.603H12.5115L13.2484 14.3636H14.1167L13.0069 16.1818L14.1415 18H13.2573L12.5115 16.7589H12.4831L11.7374 18H10.8567L11.9949 16.1818L10.878 14.3636H11.7498ZM14.4647 14.9975V14.3636H17.4512V14.9975H16.3379V18H15.5779V14.9975H14.4647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTxt);
export default __webpack_public_path__ + "static/media/IconTXT.c1ab713a.svg";
export { ForwardRef as ReactComponent };